<template>
  <header class="site-header" style="position: relative">
    <router-link to="/" class="main-logo-wrap">
      <img
        class="main-logo"
        :src="'/local/templates/main/images/logo' + $config.id + '.png'"
        width="212"
        height="72"
      />
    </router-link>

    <div class="navigation_top pl-3">
      <div class="social_full">
        <!--<a href="/wherebuy/index.html">Найти дилера</a>-->

        <div class="social ml-1">
          <!-- <a href="/search/" class="search"> </a> -->
          <a
            href="https://www.youtube.com/channel/UCv7nCThKuu8THNqAzf6-9FA"
            target="_blank"
            ><i class="fa fa-youtube"></i></a>
          <a href="https://instagram.com/sikarussia/ " target="_blank"
            ><i class="fa fa-instagram"></i></a>
          <a
            href="https://www.facebook.com/SikaRussia/?ref=bookmarks"
            target="_blank"
            ><i class="fa fa-facebook"></i></a>
          <a href="http://vk.com/sikarussia " target="_blank"
            ><i class="fa fa-vk"></i></a>
        </div>
      </div>

      <div class="social_mobile">
        <!-- <a href="/search/" class="search"> </a> -->
        <a
          href="https://www.youtube.com/channel/UCv7nCThKuu8THNqAzf6-9FA"
          target="_blank"
          ><i class="fa fa-youtube"></i></a>
        <a href="https://instagram.com/sikarussia/ " target="_blank"
          ><i class="fa fa-instagram"></i></a>
        <a
          href="https://www.facebook.com/SikaRussia/?ref=bookmarks"
          target="_blank"
          ><i class="fa fa-facebook"></i></a>
        <a href="http://vk.com/sikarussia " target="_blank"
          ><i class="fa fa-vk"></i></a>
        <!--<a class="wherebuy" href="/wherebuy/index.html">Найти дилера</a>-->
      </div>

      <nav>
        <div id="bxdynamic_LkGdQn_start" style="display:none"></div>
        <nav>
          <ul id="horizontal-multilevel-menu" @click="onClickMob">
            <li>
              <router-link :to="{ name: 'about' }" class="root-item"
                >о компании
                <div class="open_menu"></div>
              </router-link>
              <ul @click="onClickDesktop">
                <li>
                  <router-link :to="{ name: 'about' }">О компании</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'plants' }"
                    >Заводы Sika в России</router-link
                  >
                </li>
                <li>
                  <router-link :to="{ name: 'innovations' }"
                    >Инновации</router-link
                  >
                </li>
                <li>
                  <router-link :to="{ name: 'labs' }"
                    >Лаборатории Sika в России</router-link
                  >
                </li>
                <li>
                  <router-link :to="{ name: 'articles' }">Статьи</router-link>
                </li>
              </ul>
            </li>
            <li>
              <router-link :to="{ name: 'categories' }" class="root-item"
                >продукция
                <div class="open_menu"></div>
              </router-link>
              <ul @click="onClickDesktop">
                <li v-for="(category, id) in cat" :key="id">
                  <router-link
                    :to="{ name: 'category', params: { groupId: category.id } }"
                  >
                    {{ category.name }}</router-link
                  >
                </li>
              </ul>
            </li>
            <li>
              <router-link :to="{ name: 'calc' }" class="root-item"
                >калькулятор</router-link
              >
            </li>
            <!--<li><a href="/wherebuy/index.html" class="root-item">где купить</a></li>-->
            <li>
              <router-link :to="{ name: 'contacts' }" class="root-item"
                >контакты</router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'pay' }" class="root-item"
                >доставка и оплата</router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'solutions' }" class="root-item"
                >Решения для дома</router-link
              >
            </li>
          </ul>
        </nav>
        <div class="menu-clear-left"></div>
        <div id="bxdynamic_LkGdQn_end" style="display:none"></div>
      </nav>
    </div>

    <cart mini class="cart" />

    <div class="menu-toggle-wrap">
      <a
        href="javascript:void(0)"
        id="menu-toggle-wrapper"
        ref="menuToggleWrapper"
      >
        <div id="menu-toggle"></div>
      </a>
    </div>
  </header>
</template>

<script>
import { mapState } from "vuex";
export default {
  methods: {
    onClickMob() {
      if (this.$vuetify.breakpoint.mdAndDown) {
        this.$refs.menuToggleWrapper.click();
      }
    },
    onClickDesktop(event) {
      const dropdownMenu = $(event.target).closest("ul");
      dropdownMenu.css({
        display: "none",
      });
      setTimeout(() => {
        dropdownMenu.css({
          display: "",
        });
      }, 1000);
    },
  },
  computed: mapState(["cat", "articles"]),
};
</script>

<style lang="scss" scoped>
.site-header {
  display: grid;
  grid-template-columns: 3fr 15fr 1fr;

  .main-logo-wrap {
    display: flex;
    align-items: flex-end;
    padding-bottom: 18px;
  }
  #horizontal-multilevel-menu {
    li {
      padding: 0 2px;
    }
  }
  .social {
    a {
      margin-left: 5px;
    }
  }
  .cart {
    justify-self: flex-end;
    align-self: flex-end;
    margin-bottom: 18px;
    margin-right: 18px;
  }

  .menu-toggle-wrap {
    justify-self: flex-end;
    margin-right: -26px;
  }
}

@media screen and (max-width: 1100px) {
  .site-header {
    grid-template-columns: 3fr 20fr 1fr 1fr;

    .main-logo-wrap {
      margin-top: -8px;
    }
    .cart {
      margin-bottom: 31px;
      margin-right: 12px;
    }
  }
}

@media screen and (max-width: 992px) {
  .site-header {
    .cart {
      margin-right: 20px;
    }
  }
}

@media screen and (max-width: 768px) {
  .site-header {
    grid-template-columns: 3fr 8fr 1fr 1fr;
    .cart {
      margin-right: 20px;
    }
  }
  .menu-toggle-wrap {
    justify-self: flex-end;
    margin-right: -26px;
  }
}

@media screen and (max-width: 680px) {
  .site-header {
    grid-template-columns: 3fr 4fr 1fr 1fr;
    .cart {
      margin-right: 20px;
    }
  }
}
</style>
